// @flow
import * as React from 'react';
import Loadable from 'react-loadable';
// import Logo from 'app/logo';
import MainMenu from 'lib/navbar';
import MainFooter from 'lib/mainfooter/MainFooter';
// import ModalController from 'app/modal-controller'
import Infobar from 'lib/info-bar';
// import Trackr from 'applets/trackr/trackr';
// import Beta from 'applets/beta';
// import Taskd from 'applets/taskd/taskd';
import Loading from 'lib/Loading';


import {
  Route,
  Switch,
  Redirect
} from 'react-router-dom'
// import { UploadMonitor } from 'lib/uploader';
// import Frontpage from 'applets/frontpage/frontpage-container';

const Frontpage = Loadable({
  loader: () => import(/* webpackChunkName: "frontpage" */ 'applets/frontpage/frontpage-container'),
  loading: Loading,
});

const ModalController = Loadable({
  loader: () => import(/* webpackChunkName: "modals" */ 'app/modal-controller'),
  loading: Loading,
});

const Evental = Loadable({
  loader: () => import(/* webpackChunkName: "evental" */ 'applets/evental/Evental-container'),
  loading: Loading,
});

const Shout = Loadable({
  loader: () => import(/* webpackChunkName: "shout" */ 'applets/shout/Shout'),
  loading: Loading,
});

const Directr = Loadable({
  loader: () => import(/* webpackChunkName: "directr" */ 'applets/directr/Directr'),
  loading: Loading,
});

const Mailr = Loadable({
  loader: () => import(/* webpackChunkName: "mailr" */ 'applets/mailr/Mailr'),
  loading: Loading,
});

const MediaManager = Loadable({
  loader: () => import(/* webpackChunkName: "media" */ 'applets/media-manager'),
  loading: Loading,
});

const ERR404 = Loadable({
  loader: () => import(/* webpackChunkName: "404" */ 'lib/404'),
  loading: Loading,
});

const ErrorBoundary = Loadable({
  loader: () => import(/* webpackChunkName: "errors" */ 'lib/error-boundary'),
  loading: Loading,
});
const UploadMonitor = Loadable({
  loader: () => import(/* webpackChunkName: "uploader" */ 'lib/uploader'), render(loaded, props) {
    let Component = loaded.UploadMonitor;
    return <Component {...props} />;
  },
  loading: Loading,
});

class App extends React.Component<*> {

  render() {
    return <React.Fragment>
      {/* <div className="app"> */}
      <ErrorBoundary>
        <Route path="/" children={(rest) => <MainMenu {...rest} />} />
        <Route path="/" children={(rest) => <Infobar {...rest} />} />
      </ErrorBoundary>
      <ErrorBoundary>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
          <Route exact path="/dashboard" component={Frontpage} />
          <Route path="/evental" component={Evental} />
          <Route path="/shout" component={Shout} />
          <Route path="/directr" component={Directr} />
          <Route path="/mailr" component={Mailr} />
          {/* <Route path="/trackr" component={Trackr}/> */}
          {/* <Route path="/beta" component={Beta}/> */}
          <Route path="/media" component={MediaManager} />
          {/* <Route path="/taskd" component={Taskd}/> */}
          <Route path="*" component={ERR404} />
        </Switch>
      </ErrorBoundary>
      <MainFooter />
      <UploadMonitor />
    {/* </div> */}
      {/* <Logo /> */}
      <Route path="/" children={(rest) => <ModalController {...rest} />} />

      </React.Fragment>
  }
}
export default App